import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <h3>ProAd.Live</h3>
      <div className="footer-link">
        <a href="/privacy-policy">Privacy policy</a>
        <p className="divider">|</p>
        <a href="/disclaimer">Disclaimer</a>
        <p className="divider">|</p>
        <a href="/data-deletion">Data Deletion</a>
      </div>

      <p style={{ color: "white", marginTop: 4 }}>
        CONTACT: 21 rue de l'Innovation, Roeser (Kockelscheuer ) 1896, Luxembourg
      </p>
    </div>
  );
};

export default Footer;
